// PageConnect — Global currencies and country codes
// Excludes sanctioned countries: Iran, North Korea, Russia, Israel, Syria, Cuba, Venezuela

export const CURRENCIES = {
  BDT: { symbol: '৳', label: 'Bangladeshi Taka', flag: '🇧🇩', country: 'Bangladesh' },
  USD: { symbol: '$', label: 'US Dollar', flag: '🇺🇸', country: 'United States' },
  GBP: { symbol: '£', label: 'British Pound', flag: '🇬🇧', country: 'United Kingdom' },
  EUR: { symbol: '€', label: 'Euro', flag: '🇪🇺', country: 'Europe' },
  AUD: { symbol: 'A$', label: 'Australian Dollar', flag: '🇦🇺', country: 'Australia' },
  CAD: { symbol: 'C$', label: 'Canadian Dollar', flag: '🇨🇦', country: 'Canada' },
  NZD: { symbol: 'NZ$', label: 'New Zealand Dollar', flag: '🇳🇿', country: 'New Zealand' },
  SGD: { symbol: 'S$', label: 'Singapore Dollar', flag: '🇸🇬', country: 'Singapore' },
  MYR: { symbol: 'RM', label: 'Malaysian Ringgit', flag: '🇲🇾', country: 'Malaysia' },
  INR: { symbol: '₹', label: 'Indian Rupee', flag: '🇮🇳', country: 'India' },
  PKR: { symbol: '₨', label: 'Pakistani Rupee', flag: '🇵🇰', country: 'Pakistan' },
  AED: { symbol: 'د.إ', label: 'UAE Dirham', flag: '🇦🇪', country: 'UAE' },
  SAR: { symbol: '﷼', label: 'Saudi Riyal', flag: '🇸🇦', country: 'Saudi Arabia' },
  QAR: { symbol: '﷼', label: 'Qatari Riyal', flag: '🇶🇦', country: 'Qatar' },
  KWD: { symbol: 'د.ك', label: 'Kuwaiti Dinar', flag: '🇰🇼', country: 'Kuwait' },
  OMR: { symbol: '﷼', label: 'Omani Rial', flag: '🇴🇲', country: 'Oman' },
  BHD: { symbol: '.د.ب', label: 'Bahraini Dinar', flag: '🇧🇭', country: 'Bahrain' },
  JOD: { symbol: 'د.ا', label: 'Jordanian Dinar', flag: '🇯🇴', country: 'Jordan' },
  LBP: { symbol: 'ل.ل', label: 'Lebanese Pound', flag: '🇱🇧', country: 'Lebanon' },
  EGP: { symbol: '£', label: 'Egyptian Pound', flag: '🇪🇬', country: 'Egypt' },
  TRY: { symbol: '₺', label: 'Turkish Lira', flag: '🇹🇷', country: 'Turkey' },
  CNY: { symbol: '¥', label: 'Chinese Yuan', flag: '🇨🇳', country: 'China' },
  JPY: { symbol: '¥', label: 'Japanese Yen', flag: '🇯🇵', country: 'Japan' },
  KRW: { symbol: '₩', label: 'South Korean Won', flag: '🇰🇷', country: 'South Korea' },
  MMK: { symbol: 'K', label: 'Myanmar Kyat', flag: '🇲🇲', country: 'Myanmar' },
  LKR: { symbol: '₨', label: 'Sri Lankan Rupee', flag: '🇱🇰', country: 'Sri Lanka' },
  NPR: { symbol: '₨', label: 'Nepalese Rupee', flag: '🇳🇵', country: 'Nepal' },
  MXN: { symbol: '$', label: 'Mexican Peso', flag: '🇲🇽', country: 'Mexico' },
  BRL: { symbol: 'R$', label: 'Brazilian Real', flag: '🇧🇷', country: 'Brazil' },
  ARS: { symbol: '$', label: 'Argentine Peso', flag: '🇦🇷', country: 'Argentina' },
  CLP: { symbol: '$', label: 'Chilean Peso', flag: '🇨🇱', country: 'Chile' },
  COP: { symbol: '$', label: 'Colombian Peso', flag: '🇨🇴', country: 'Colombia' },
  ZAR: { symbol: 'R', label: 'South African Rand', flag: '🇿🇦', country: 'South Africa' },
  NGN: { symbol: '₦', label: 'Nigerian Naira', flag: '🇳🇬', country: 'Nigeria' },
  GHS: { symbol: '₵', label: 'Ghanaian Cedi', flag: '🇬🇭', country: 'Ghana' },
  KES: { symbol: 'KSh', label: 'Kenyan Shilling', flag: '🇰🇪', country: 'Kenya' },
  ETB: { symbol: 'Br', label: 'Ethiopian Birr', flag: '🇪🇹', country: 'Ethiopia' },
  TZS: { symbol: 'TSh', label: 'Tanzanian Shilling', flag: '🇹🇿', country: 'Tanzania' },
  UGX: { symbol: 'USh', label: 'Ugandan Shilling', flag: '🇺🇬', country: 'Uganda' },
  CHF: { symbol: 'Fr', label: 'Swiss Franc', flag: '🇨🇭', country: 'Switzerland' },
  SEK: { symbol: 'kr', label: 'Swedish Krona', flag: '🇸🇪', country: 'Sweden' },
  NOK: { symbol: 'kr', label: 'Norwegian Krone', flag: '🇳🇴', country: 'Norway' },
  DKK: { symbol: 'kr', label: 'Danish Krone', flag: '🇩🇰', country: 'Denmark' },
  PLN: { symbol: 'zł', label: 'Polish Zloty', flag: '🇵🇱', country: 'Poland' },
  CZK: { symbol: 'Kč', label: 'Czech Koruna', flag: '🇨🇿', country: 'Czech Republic' },
  HUF: { symbol: 'Ft', label: 'Hungarian Forint', flag: '🇭🇺', country: 'Hungary' },
  RON: { symbol: 'lei', label: 'Romanian Leu', flag: '🇷🇴', country: 'Romania' },
  UAH: { symbol: '₴', label: 'Ukrainian Hryvnia', flag: '🇺🇦', country: 'Ukraine' },
  IDR: { symbol: 'Rp', label: 'Indonesian Rupiah', flag: '🇮🇩', country: 'Indonesia' },
  THB: { symbol: '฿', label: 'Thai Baht', flag: '🇹🇭', country: 'Thailand' },
  VND: { symbol: '₫', label: 'Vietnamese Dong', flag: '🇻🇳', country: 'Vietnam' },
  PHP: { symbol: '₱', label: 'Philippine Peso', flag: '🇵🇭', country: 'Philippines' },
  TWD: { symbol: 'NT$', label: 'Taiwan Dollar', flag: '🇹🇼', country: 'Taiwan' },
  HKD: { symbol: 'HK$', label: 'Hong Kong Dollar', flag: '🇭🇰', country: 'Hong Kong' },
  MOP: { symbol: 'P', label: 'Macanese Pataca', flag: '🇲🇴', country: 'Macau' },
  KHR: { symbol: '៛', label: 'Cambodian Riel', flag: '🇰🇭', country: 'Cambodia' },
  LAK: { symbol: '₭', label: 'Lao Kip', flag: '🇱🇦', country: 'Laos' },
  BND: { symbol: 'B$', label: 'Brunei Dollar', flag: '🇧🇳', country: 'Brunei' },
  MVR: { symbol: 'Rf', label: 'Maldivian Rufiyaa', flag: '🇲🇻', country: 'Maldives' },
  AFN: { symbol: '؋', label: 'Afghan Afghani', flag: '🇦🇫', country: 'Afghanistan' },
  UZS: { symbol: 'soʻm', label: 'Uzbekistani Som', flag: '🇺🇿', country: 'Uzbekistan' },
  KZT: { symbol: '₸', label: 'Kazakhstani Tenge', flag: '🇰🇿', country: 'Kazakhstan' },
  AZN: { symbol: '₼', label: 'Azerbaijani Manat', flag: '🇦🇿', country: 'Azerbaijan' },
  GEL: { symbol: '₾', label: 'Georgian Lari', flag: '🇬🇪', country: 'Georgia' },
  AMD: { symbol: '֏', label: 'Armenian Dram', flag: '🇦🇲', country: 'Armenia' },
  IQD: { symbol: 'ع.د', label: 'Iraqi Dinar', flag: '🇮🇶', country: 'Iraq' },
  YER: { symbol: '﷼', label: 'Yemeni Rial', flag: '🇾🇪', country: 'Yemen' },
  MAD: { symbol: 'د.م.', label: 'Moroccan Dirham', flag: '🇲🇦', country: 'Morocco' },
  TND: { symbol: 'د.ت', label: 'Tunisian Dinar', flag: '🇹🇳', country: 'Tunisia' },
  DZD: { symbol: 'د.ج', label: 'Algerian Dinar', flag: '🇩🇿', country: 'Algeria' },
  LYD: { symbol: 'ل.د', label: 'Libyan Dinar', flag: '🇱🇾', country: 'Libya' },
  SDG: { symbol: '£', label: 'Sudanese Pound', flag: '🇸🇩', country: 'Sudan' },
  SOS: { symbol: 'Sh', label: 'Somali Shilling', flag: '🇸🇴', country: 'Somalia' },
  MZN: { symbol: 'MT', label: 'Mozambican Metical', flag: '🇲🇿', country: 'Mozambique' },
  ZMW: { symbol: 'ZK', label: 'Zambian Kwacha', flag: '🇿🇲', country: 'Zambia' },
  MWK: { symbol: 'MK', label: 'Malawian Kwacha', flag: '🇲🇼', country: 'Malawi' },
  BWP: { symbol: 'P', label: 'Botswana Pula', flag: '🇧🇼', country: 'Botswana' },
  NAD: { symbol: '$', label: 'Namibian Dollar', flag: '🇳🇦', country: 'Namibia' },
  MUR: { symbol: '₨', label: 'Mauritian Rupee', flag: '🇲🇺', country: 'Mauritius' },
  SCR: { symbol: '₨', label: 'Seychellois Rupee', flag: '🇸🇨', country: 'Seychelles' },
}

export const CURRENCY_LIST = Object.entries(CURRENCIES).map(([code, data]) => ({
  code,
  ...data,
  searchText: (code + ' ' + data.label + ' ' + data.country).toLowerCase(),
}))

export function getCurrencySymbol(currencyCode) {
  return CURRENCIES[currencyCode]?.symbol || '৳'
}

export function getCurrencyLabel(currencyCode) {
  return CURRENCIES[currencyCode]?.label || 'Bangladeshi Taka'
}

export function getCurrencyFlag(currencyCode) {
  return CURRENCIES[currencyCode]?.flag || '🇧🇩'
}

// ─── COUNTRY PHONE CODES ───────────────────────────────────────────────────

export const COUNTRY_CODES = [
  { code: '+880', country: 'Bangladesh', flag: '🇧🇩' },
  { code: '+1', country: 'USA / Canada', flag: '🇺🇸' },
  { code: '+44', country: 'United Kingdom', flag: '🇬🇧' },
  { code: '+61', country: 'Australia', flag: '🇦🇺' },
  { code: '+64', country: 'New Zealand', flag: '🇳🇿' },
  { code: '+65', country: 'Singapore', flag: '🇸🇬' },
  { code: '+60', country: 'Malaysia', flag: '🇲🇾' },
  { code: '+91', country: 'India', flag: '🇮🇳' },
  { code: '+92', country: 'Pakistan', flag: '🇵🇰' },
  { code: '+971', country: 'UAE', flag: '🇦🇪' },
  { code: '+966', country: 'Saudi Arabia', flag: '🇸🇦' },
  { code: '+974', country: 'Qatar', flag: '🇶🇦' },
  { code: '+965', country: 'Kuwait', flag: '🇰🇼' },
  { code: '+968', country: 'Oman', flag: '🇴🇲' },
  { code: '+973', country: 'Bahrain', flag: '🇧🇭' },
  { code: '+962', country: 'Jordan', flag: '🇯🇴' },
  { code: '+961', country: 'Lebanon', flag: '🇱🇧' },
  { code: '+20', country: 'Egypt', flag: '🇪🇬' },
  { code: '+90', country: 'Turkey', flag: '🇹🇷' },
  { code: '+86', country: 'China', flag: '🇨🇳' },
  { code: '+81', country: 'Japan', flag: '🇯🇵' },
  { code: '+82', country: 'South Korea', flag: '🇰🇷' },
  { code: '+95', country: 'Myanmar', flag: '🇲🇲' },
  { code: '+94', country: 'Sri Lanka', flag: '🇱🇰' },
  { code: '+977', country: 'Nepal', flag: '🇳🇵' },
  { code: '+52', country: 'Mexico', flag: '🇲🇽' },
  { code: '+55', country: 'Brazil', flag: '🇧🇷' },
  { code: '+54', country: 'Argentina', flag: '🇦🇷' },
  { code: '+56', country: 'Chile', flag: '🇨🇱' },
  { code: '+57', country: 'Colombia', flag: '🇨🇴' },
  { code: '+27', country: 'South Africa', flag: '🇿🇦' },
  { code: '+234', country: 'Nigeria', flag: '🇳🇬' },
  { code: '+233', country: 'Ghana', flag: '🇬🇭' },
  { code: '+254', country: 'Kenya', flag: '🇰🇪' },
  { code: '+251', country: 'Ethiopia', flag: '🇪🇹' },
  { code: '+255', country: 'Tanzania', flag: '🇹🇿' },
  { code: '+256', country: 'Uganda', flag: '🇺🇬' },
  { code: '+41', country: 'Switzerland', flag: '🇨🇭' },
  { code: '+46', country: 'Sweden', flag: '🇸🇪' },
  { code: '+47', country: 'Norway', flag: '🇳🇴' },
  { code: '+45', country: 'Denmark', flag: '🇩🇰' },
  { code: '+48', country: 'Poland', flag: '🇵🇱' },
  { code: '+420', country: 'Czech Republic', flag: '🇨🇿' },
  { code: '+36', country: 'Hungary', flag: '🇭🇺' },
  { code: '+40', country: 'Romania', flag: '🇷🇴' },
  { code: '+380', country: 'Ukraine', flag: '🇺🇦' },
  { code: '+49', country: 'Germany', flag: '🇩🇪' },
  { code: '+33', country: 'France', flag: '🇫🇷' },
  { code: '+39', country: 'Italy', flag: '🇮🇹' },
  { code: '+34', country: 'Spain', flag: '🇪🇸' },
  { code: '+351', country: 'Portugal', flag: '🇵🇹' },
  { code: '+30', country: 'Greece', flag: '🇬🇷' },
  { code: '+31', country: 'Netherlands', flag: '🇳🇱' },
  { code: '+32', country: 'Belgium', flag: '🇧🇪' },
  { code: '+43', country: 'Austria', flag: '🇦🇹' },
  { code: '+353', country: 'Ireland', flag: '🇮🇪' },
  { code: '+358', country: 'Finland', flag: '🇫🇮' },
  { code: '+62', country: 'Indonesia', flag: '🇮🇩' },
  { code: '+66', country: 'Thailand', flag: '🇹🇭' },
  { code: '+84', country: 'Vietnam', flag: '🇻🇳' },
  { code: '+63', country: 'Philippines', flag: '🇵🇭' },
  { code: '+886', country: 'Taiwan', flag: '🇹🇼' },
  { code: '+852', country: 'Hong Kong', flag: '🇭🇰' },
  { code: '+853', country: 'Macau', flag: '🇲🇴' },
  { code: '+855', country: 'Cambodia', flag: '🇰🇭' },
  { code: '+856', country: 'Laos', flag: '🇱🇦' },
  { code: '+673', country: 'Brunei', flag: '🇧🇳' },
  { code: '+960', country: 'Maldives', flag: '🇲🇻' },
  { code: '+93', country: 'Afghanistan', flag: '🇦🇫' },
  { code: '+998', country: 'Uzbekistan', flag: '🇺🇿' },
  { code: '+7', country: 'Kazakhstan', flag: '🇰🇿' },
  { code: '+994', country: 'Azerbaijan', flag: '🇦🇿' },
  { code: '+995', country: 'Georgia', flag: '🇬🇪' },
  { code: '+374', country: 'Armenia', flag: '🇦🇲' },
  { code: '+964', country: 'Iraq', flag: '🇮🇶' },
  { code: '+967', country: 'Yemen', flag: '🇾🇪' },
  { code: '+212', country: 'Morocco', flag: '🇲🇦' },
  { code: '+216', country: 'Tunisia', flag: '🇹🇳' },
  { code: '+213', country: 'Algeria', flag: '🇩🇿' },
  { code: '+218', country: 'Libya', flag: '🇱🇾' },
  { code: '+249', country: 'Sudan', flag: '🇸🇩' },
  { code: '+252', country: 'Somalia', flag: '🇸🇴' },
  { code: '+258', country: 'Mozambique', flag: '🇲🇿' },
  { code: '+260', country: 'Zambia', flag: '🇿🇲' },
  { code: '+265', country: 'Malawi', flag: '🇲🇼' },
  { code: '+267', country: 'Botswana', flag: '🇧🇼' },
  { code: '+264', country: 'Namibia', flag: '🇳🇦' },
  { code: '+230', country: 'Mauritius', flag: '🇲🇺' },
  { code: '+248', country: 'Seychelles', flag: '🇸🇨' },
]

export const COUNTRY_CODE_LIST = COUNTRY_CODES.map(c => ({
  ...c,
  searchText: (c.code + ' ' + c.country).toLowerCase(),
}))